import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getErrorCode, getErrorStatusCode } from "../../../../api/api-response";
import { ILoginAsResponse } from "../../../models/auth/login-as.response";
import { RestEndpoints } from "../../../../api/endpoints";
import getInstance from "../../../../utils/rest";
import { SharedQueryKeys } from "../../query-keys";

const LogoutAs = async (): Promise<ILoginAsResponse> => {
  const { data } = await getInstance().post<ILoginAsResponse>(RestEndpoints.LogoutAsUser);
  return data;
};

export const useLogoutAsQuery = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => LogoutAs(),
    onError: (error) => {
      const errorMsg = getErrorCode(error);
      const errorCode = getErrorStatusCode(error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    },
    onSuccess: () => {
      enqueueSnackbar(t("basedata.users.login.successLogout"), { variant: "success" });
      void queryClient.invalidateQueries({ queryKey: [SharedQueryKeys.GetUser] });
    },
  });
};
